// frontend/src/components/public-info/sections/FAQSection.tsx
import React, { useState } from "react";
import SectionContainer from "../shared/SectionContainer";
import SectionTitle from "../shared/SectionTitle";
import "./FAQSection.css";

export type FAQItem = {
  question: string;
  answer: string;
};

type FAQSectionProps = {
  id?: string;
  title: string;
  subtitle?: string;
  items: FAQItem[];
  card?: boolean;
};

const ChevronIcon: React.FC<{ isOpen: boolean }> = ({ isOpen }) => (
  <svg
    className={`ocf-pi-faq-chevron ${isOpen ? "is-open" : ""}`}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const FAQSection: React.FC<FAQSectionProps> = ({
  id,
  title,
  subtitle,
  items,
  card = true,
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <SectionContainer id={id} card={card}>
      <SectionTitle title={title} subtitle={subtitle} />
      <div className="ocf-pi-faq-list">
        {items.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={index} className="ocf-pi-faq-item">
              <button
                className="ocf-pi-faq-question"
                onClick={() => toggleItem(index)}
                aria-expanded={isOpen}
                aria-controls={`faq-answer-${id}-${index}`}
              >
                <span>{item.question}</span>
                <ChevronIcon isOpen={isOpen} />
              </button>
              <div
                id={`faq-answer-${id}-${index}`}
                className={`ocf-pi-faq-answer ${isOpen ? "is-open" : ""}`}
                role="region"
                aria-hidden={!isOpen}
              >
                <div className="ocf-pi-faq-answer-content">{item.answer}</div>
              </div>
            </div>
          );
        })}
      </div>
    </SectionContainer>
  );
};

export default FAQSection;
